/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./MonthlyComment.vue?vue&type=template&id=75d119b5&scoped=true&"
import script from "./MonthlyComment.vue?vue&type=script&lang=js&"
export * from "./MonthlyComment.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyComment.vue?vue&type=style&index=0&id=75d119b5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d119b5",
  null
  
)

export default component.exports